import React from "react";
import { Box, Button, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";

const CAL_URL = "https://cal.com/lutian/coach15";

const useStyles = makeStyles((theme) => ({
  hero: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: theme.spacing(8),
    alignItems: "center",
    maxWidth: 1120,
    margin: "0 auto",
    padding: theme.spacing(16, 3, 10, 3),
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "1fr",
      padding: theme.spacing(12, 2, 6, 2),
      gap: theme.spacing(5),
      textAlign: "center",
    },
  },
  portraitWrap: {
    position: "relative",
    aspectRatio: "1 / 1",
    maxWidth: 480,
    justifySelf: "end",
    width: "100%",
    borderRadius: 24,
    overflow: "hidden",
    boxShadow:
      "0 30px 80px -20px rgba(0,0,0,0.6), 0 0 0 1px rgba(255,255,255,0.06) inset",
    [theme.breakpoints.down("sm")]: {
      justifySelf: "center",
      maxWidth: 320,
    },
  },
  portraitImg: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block",
    filter: "saturate(0.95) contrast(1.02)",
    transform: "scale(1.02)",
  },
  portraitGlow: {
    position: "absolute",
    inset: 0,
    pointerEvents: "none",
    background:
      "radial-gradient(120% 60% at 50% 100%, rgba(0,0,0,0.35), transparent 55%)",
  },
  copy: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
      alignItems: "center",
    },
  },
  eyebrow: {
    fontFamily: "Roboto Mono, monospace",
    fontSize: "0.72rem",
    letterSpacing: "0.22em",
    textTransform: "uppercase",
    color: "rgba(255,255,255,0.55)",
  },
  name: {
    fontFamily: "Roboto, sans-serif",
    fontSize: "3.5rem",
    fontWeight: 300,
    lineHeight: 1.05,
    letterSpacing: "-0.02em",
    color: "#fafafa",
    [theme.breakpoints.down("sm")]: {
      fontSize: "2.4rem",
    },
  },
  tagline: {
    fontFamily: "Roboto, sans-serif",
    fontSize: "1.15rem",
    fontWeight: 300,
    color: "rgba(255,255,255,0.75)",
    lineHeight: 1.4,
    maxWidth: 420,
  },
  taglineAccent: {
    color: "#00bfbf",
  },
  ctaRow: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
    marginTop: theme.spacing(2),
    flexWrap: "wrap",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "center",
    },
  },
  cta: {
    fontFamily: "Roboto Mono, monospace",
    fontSize: "0.9rem",
    fontWeight: 500,
    letterSpacing: "0.02em",
    color: "#111111",
    backgroundColor: "#00bfbf",
    padding: theme.spacing(1.5, 3),
    borderRadius: 999,
    textTransform: "none",
    boxShadow:
      "0 10px 30px -8px rgba(0,191,191,0.55), 0 2px 6px -1px rgba(0,0,0,0.4)",
    transition: "transform 0.4s ease, box-shadow 0.4s ease, background-color 0.4s ease",
    "&:hover": {
      backgroundColor: "#00d4d4",
      transform: "translateY(-1px)",
      boxShadow:
        "0 14px 34px -8px rgba(0,191,191,0.65), 0 2px 6px -1px rgba(0,0,0,0.4)",
    },
  },
  ctaIcon: {
    marginLeft: theme.spacing(1),
    fontSize: "1rem",
  },
  ctaFine: {
    fontFamily: "Roboto Mono, monospace",
    fontSize: "0.72rem",
    color: "rgba(255,255,255,0.45)",
    letterSpacing: "0.04em",
  },
}));

export const Hero = ({ portraitSrc }) => {
  const classes = useStyles();

  return (
    <Box className={classes.hero}>
      <Box className={classes.portraitWrap}>
        <img
          className={classes.portraitImg}
          src={portraitSrc}
          alt="Lucian Lazar"
          loading="eager"
        />
        <Box className={classes.portraitGlow} />
      </Box>

      <Box className={classes.copy}>
        <Typography className={classes.eyebrow}>Life coaching</Typography>
        <Typography component="h1" className={classes.name}>
          Lucian Lazar
        </Typography>
        <Typography className={classes.tagline}>
          Habit-first,{" "}
          <span className={classes.taglineAccent}>not motivation-first.</span>{" "}
          Whether you want to change something or just think out loud, we'll figure it out on the call.
        </Typography>

        <Box className={classes.ctaRow}>
          <Button
            className={classes.cta}
            href={CAL_URL}
            target="_blank"
            rel="noopener noreferrer"
            disableElevation
          >
            Book a free 15-min intro call
            <ArrowForwardIcon className={classes.ctaIcon} />
          </Button>
          {/* <Typography className={classes.ctaFine}>
            No pitch, no pressure.
          </Typography> */}
        </Box>
      </Box>
    </Box>
  );
};
